module.exports = __webpack_public_path__ + "img/fraude_two.17c2ddb0.png";